var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u269B\uFE0F Atoms / Icons / 03-Medium / Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u269B\\uFE0F-Atoms-/-Icons-/-03-Medium-/-Search"
  }, /*#__PURE__*/React.createElement("path", {
    className: "test",
    d: "M19.9796579,10.3591435 C20.2672622,10.8306329 20.1181938,11.4459999 19.6467044,11.7336041 C19.1752151,12.0212084 18.5598481,11.8721401 18.2722438,11.4006507 C17.3696039,9.92089124 15.7648684,9 14,9 C13.4477153,9 13,8.55228475 13,8 C13,7.44771525 13.4477153,7 14,7 C16.4694605,7 18.7175518,8.29008649 19.9796579,10.3591435 Z M20.2928932,21.7071068 C19.9023689,21.3165825 19.9023689,20.6834175 20.2928932,20.2928932 C20.6834175,19.9023689 21.3165825,19.9023689 21.7071068,20.2928932 L23.7071068,22.2928932 C24.0976311,22.6834175 24.0976311,23.3165825 23.7071068,23.7071068 C23.3165825,24.0976311 22.6834175,24.0976311 22.2928932,23.7071068 L20.2928932,21.7071068 Z M20,15 C19.4477153,15 19,14.5522847 19,14 C19,13.4477153 19.4477153,13 20,13 C20.5522847,13 21,13.4477153 21,14 C21,14.5522847 20.5522847,15 20,15 Z",
    id: "2nd-tone",
    fill: "#CC8F2F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "test",
    d: "M14,22 C18.418278,22 22,18.418278 22,14 C22,9.581722 18.418278,6 14,6 C9.581722,6 6,9.581722 6,14 C6,18.418278 9.581722,22 14,22 Z M14,24 C8.4771525,24 4,19.5228475 4,14 C4,8.4771525 8.4771525,4 14,4 C19.5228475,4 24,8.4771525 24,14 C24,19.5228475 19.5228475,24 14,24 Z M24.7071068,25.2928932 C24.8688672,25.4546537 25.1311328,25.4546537 25.2928932,25.2928932 C25.4546537,25.1311328 25.4546537,24.8688672 25.2928932,24.7071068 L24.1880813,23.6022949 C23.9986075,23.8032536 23.8032536,23.9986075 23.6022949,24.1880813 L24.7071068,25.2928932 Z M24.0198509,20.6056373 L26.7071068,23.2928932 C27.6499158,24.2357023 27.6499158,25.7642977 26.7071068,26.7071068 C25.7642977,27.6499158 24.2357023,27.6499158 23.2928932,26.7071068 L20.6056373,24.0198509 C21.9612046,23.124383 23.124383,21.9612046 24.0198509,20.6056373 Z",
    id: "1st-tone",
    fill: "#BF7703"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.45bc9655d743ceb55bb32dae7bf227ed.svg";
export { ForwardRef as ReactComponent };